import React from "react";
import { Flex } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { Checkbox, TextInput } from "components";
import {
  ToothEndodonticsEnum,
  ToothOralSurgeryEnum,
  ToothRestorationEnum
} from "requests";

interface InputGroupProps {
  options: {
    value: ToothOralSurgeryEnum | ToothRestorationEnum | ToothEndodonticsEnum;
    name?: string;
    label: string;
  }[];
  values: (
    | ToothOralSurgeryEnum
    | ToothRestorationEnum
    | ToothEndodonticsEnum
  )[];
  name: string;
}

const InputGroup: React.FC<InputGroupProps> = ({ options, values, name }) => {
  const { setValue } = useFormContext();

  return (
    <>
      {options.map(opt => (
        <Flex direction="column" rowGap="2" key={opt.value}>
          <Checkbox
            label={opt.label}
            isChecked={values.includes(opt.value)}
            onChange={event => {
              const { checked } = event.target;
              if (checked) {
                setValue(name, [...values, opt.value]);
              } else {
                setValue(
                  name,
                  values.filter(value => value !== opt.value)
                );
                if (opt.name) {
                  setValue(opt.name, null);
                }
              }
            }}
          />

          {opt.name && (
            <TextInput
              inputLayoutProps={{ pl: 8 }}
              labelHidden
              name={opt.name}
              label={opt.label}
              isDisabled={!values.includes(opt.value)}
            />
          )}
        </Flex>
      ))}
    </>
  );
};

export default InputGroup;
